import { createContext } from "react";

// Create the context
const UserContext = createContext(null);

export default UserContext;
